import { defineMessages } from "react-intl";
import { validator } from "lib/build/forms/ltx/phase-i/lab-procedures/autoimmun-lab-procedures/immunElfo";
import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	immunElfo: {
		id: "form.immun_elfo",
		defaultMessage: "ImmunELFO"
	},
	igG: {
		id: "form.immun_elfo.igg",
		defaultMessage: "IgG"
	},
	igA: {
		id: "form.immun_elfo.iga",
		defaultMessage: "IgA"
	},
	igM: {
		id: "form.immun_elfo.igm",
		defaultMessage: "IgM"
	}
});

const fields: { [key: string]: FieldData } = {
	igG: {
		type: "field",
		path: ["IgG"],
		label: messages.igG,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	},
	igA: {
		type: "field",
		path: ["IgA"],
		label: messages.igA,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	},
	igM: {
		type: "field",
		path: ["IgM"],
		label: messages.igM,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	}
};

const fieldset: FieldsetData = {
	rows: [
		{ columns: [{ width: 12, field: fields.igG }] },
		{ columns: [{ width: 12, field: fields.igA }] },
		{ columns: [{ width: 12, field: fields.igM }] }
	]
};

export const node: LeafNode = {
	id: "immunElfo",
	value: {
		title: messages.immunElfo,
		validator,
		fieldset,
		isImportant: true
	}
};
